import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { GlobalStyle } from "./globalStyles";
import Hero from "./component/Hero";
import Products from './component/Products';
import { ProductData, ProductDataDesert } from './component/Products/data';
import Feture from './component/Feature/inde';
import Footer from './component/Footer';
import About from './component/About';

function App() {
  return (
    <div className="App">
      <Router>
        <GlobalStyle />
        <Hero />
        <Products Heading='Chose Your Favorite !' data={ProductData} />
        <Feture />
        <div className='dessert'>
          <Products Heading='Sweet Treat For You !' data={ProductDataDesert} />
        </div>
        <About/>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
